export function scrollTo(el) {
  let body = document.body.getBoundingClientRect();
  let top = el.getBoundingClientRect();

  window.scrollTo({ top: top.top - 75 - body.top, behavior: "smooth" });
}
